class CollectionsTabs extends HTMLElement {
  constructor() {
    super();
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.tabList = this.querySelector('[role="tablist"], [name="title"], [part="tab-list"]');
    this.panelWrapper = this.querySelector('[name="content"], [part="tab-panels"]');
    this.buttons = Array.from(this.tabList?.querySelectorAll('button') || []);
    this.panels = Array.from(this.panelWrapper?.children || []).filter((panel) => panel.id);

    if (!this.buttons.length || !this.panels.length) {
      return;
    }

    this.tabList?.setAttribute('role', 'tablist');

    this.buttons.forEach((button, index) => {
      button.setAttribute('role', 'tab');
      button.setAttribute('tabindex', '-1');
      button.removeEventListener('click', button._collectionsTabsClickHandler);

      button._collectionsTabsClickHandler = () => {
        this.selectTab(index);
      };

      button.addEventListener('click', button._collectionsTabsClickHandler);
    });

    this.panels.forEach((panel, index) => {
      const button = this.buttons[index];

      panel.setAttribute('role', 'tabpanel');

      if (button?.dataset.sliderId) {
        button.setAttribute('aria-controls', button.dataset.sliderId);
      } else if (panel.id) {
        button?.setAttribute('aria-controls', panel.id);
      }
    });

    this.removeEventListener('keydown', this.handleKeydown);
    this.addEventListener('keydown', this.handleKeydown);

    const initiallySelectedIndex = this.buttons.findIndex((button) => button.getAttribute('aria-selected') === 'true');
    this.selectTab(initiallySelectedIndex >= 0 ? initiallySelectedIndex : 0);
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.handleKeydown);

    this.buttons?.forEach((button) => {
      if (button._collectionsTabsClickHandler) {
        button.removeEventListener('click', button._collectionsTabsClickHandler);
      }
    });
  }

  selectTab(index) {
    const nextIndex = Math.max(0, Math.min(index, this.buttons.length - 1));
    const activeButton = this.buttons[nextIndex];
    const activePanelId = activeButton?.dataset.sliderId;
    let activePanel = null;

    this.buttons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === nextIndex;
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === activePanelId;
      if (isActive) {
        activePanel = panel;
      }
      panel.hidden = !isActive;
      panel.classList.toggle('hidden', !isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.resetPanelScroll(activePanel);
  }

  resetPanelScroll(panel) {
    if (!panel) {
      return;
    }

    const carousel = panel.querySelector('scroll-carousel');

    console.log("carousel", carousel)

    if(!carousel) return;

    carousel.scrollTo({ left: 0, top: 0, behavior: 'auto' });
  }

  handleKeydown(event) {
    const currentIndex = this.buttons.indexOf(document.activeElement);

    if (currentIndex === -1 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      return;
    }

    event.preventDefault();

    let nextIndex = currentIndex;

    if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
    } else if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % this.buttons.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.buttons.length - 1;
    }

    this.selectTab(nextIndex);
    this.buttons[nextIndex]?.focus();
  }
}

if (!window.customElements.get('collections-tabs')) {
  window.customElements.define('collections-tabs', CollectionsTabs);
}
